import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { useNavigate } from "react-router-dom";
import { useUpdateSearchParams } from "@/Hooks/useUpdateSearchParams";
import { UserFilterType } from "@/Hooks/useGetUsersFiltersQuery";
import { useMemo, useState } from "react";
import { useDebounce } from "react-use";
import { url } from "@/Helpers/general";
import { Button } from "primereact/button";
import BaseTextInput from "@/Components/Forms/Form/BaseTextInput";
import styled from "styled-components";
import ClientsDatable from "@/Components/Datatables/ClientsDatable";
import useGetClientsFiltersQuery from "@/Hooks/useGetClientsFiltersQuery";

const StyledWrap = styled.main`
    .content-container {
        margin-top: 2rem;
    }

    .page-actions {
        margin-top: 2rem;
        padding: 1rem;
        background: #fff;
        border-radius: 8px;
    }
`;


const ClientsPage = () => {
    const navigate = useNavigate();
    const updateUsersFilterHandler = useUpdateSearchParams();
    const {
        searchQuery,
    } = useGetClientsFiltersQuery();

    const [inputValue, setInputValue] = useState(searchQuery || '');


    useDebounce(
        () => {
            updateUsersFilterHandler(UserFilterType.Search, inputValue);
        },
        1000,
        [inputValue]
    );


    const requestParams = useMemo(() => {
        return {
            search: searchQuery || undefined
        };
    }, [searchQuery]);


    return (
        <PageLayout>
            <StyledWrap>
                <div className="flex justify-content-between content-header">
                    <div>
                        <h2 className="content-header__title">Clients</h2>
                    </div>
                    <Button onClick={() => navigate(url('create-client'))}>Create Client</Button>
                </div>
                <div className="flex align-items-end gap-3">
                    <BaseTextInput
                        value={inputValue || ''}
                        placeholder="Search"
                        onChange={(e) => {
                            setInputValue(e.target.value);
                        }}
                    />
                </div>
                <div className="content-container">
                    <ClientsDatable requestParams={requestParams}/>
                </div>
            </StyledWrap>

        </PageLayout>
    );
};

export default ClientsPage;